module.exports = __webpack_public_path__ + "static/img/19.c7d8f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/19.jpg
// module id = TJ1x
// module chunks = 16